import React, { ReactElement } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { withAuthentication } from 'basealpha-ui';
import App from './App';
import AppStateGate from '../state/AppStateGate';
import UserProfileGate from '../Components/UserProfileGate';
import { OAuthProvider } from 'basealpha-ui';
import Timesheets from '../Pages/Timesheets';
import Contracts from '../Pages/Contracts';
import TimesheetReview from '../Pages/TimesheetReview';
import GuestApp from './GuestApp';
import { initMixpanel, mixpanelSetUser } from '../utils/mixpanel';

initMixpanel();

export const browserHistory = createBrowserHistory();

const PrivateRoutes: React.FC = (): ReactElement => (
  <Switch>
    <Route path="/oauth/login" component={OAuthProvider} />
    <Route path="/timesheets" component={Timesheets} />
    <Route path="/contractors" component={Contracts} />
    <Route render={(): React.ReactElement => <Redirect to="/timesheets" />} />
  </Switch>
);

const internalApp: React.FC = (): ReactElement => (
  <UserProfileGate>
    <App>
      <PrivateRoutes />
    </App>
  </UserProfileGate>
);

// @ts-ignore
const AuthenticatedRoutes = withAuthentication(internalApp, {
  header: (
    <div>
      <img src={require('../assets/edari.png')} width="130px" style={{ marginLeft: '-10px' }} />
    </div>
  ),
  events: {
    onLogin: [
      async (): Promise<void> => {
        await mixpanelSetUser();
      },
    ],
  },
});

const MainRouter: React.FC = (): ReactElement => (
  <Router>
    <AppStateGate>
      <Switch>
        <Route
          path="/timesheet-review"
          render={(): React.ReactElement => (
            <GuestApp>
              <TimesheetReview />
            </GuestApp>
          )}
        />
        <Route render={(): React.ReactElement => <AuthenticatedRoutes />} />
      </Switch>
    </AppStateGate>
  </Router>
);

export default MainRouter;
